export const INPUT_WRAPPER_ORDER: ('input' | 'label' | 'description' | 'error')[] = [
  'label',
  'input',
  'description',
  'error'
];

export const INPUT_WRAPPER_ORDER_DESCRIPTION_TOP: ('input' | 'label' | 'description' | 'error')[] =
  ['label', 'description', 'input', 'error'];
